import { HttpHandler, HttpInterceptor, HttpRequest, HttpClient, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, throwError} from 'rxjs';
import {finalize} from 'rxjs/operators'
import {Router} from '@angular/router';
import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { SpinnerOverlayService } from '../services/spinner/spinner.service';
import {environment} from '../../environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { catchError } from 'rxjs/operators';

//import { AuthService } from '../services/auth/auth.service';

//import { BehaviorSubject } from 'rxjs';
@Pipe({
  name: 'secure'
})

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private router: Router, private sanitizer:DomSanitizer, private http: HttpClient,
    private readonly spinner: SpinnerOverlayService, private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
    let spinnerSubscription: Subscription;
    spinnerSubscription = this.spinner.spinner$.subscribe();
    const secureReq = req.clone({
      url: req.url.replace('http://', 'https://')
    });

   new Promise( resolve => setTimeout(resolve, 2000) );
    const authToken =   this.authService.token;
    
    const newRequest = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + authToken)
    });

    return next.handle(newRequest).pipe(
      finalize(() => {
        if(spinnerSubscription){
          spinnerSubscription.unsubscribe();
        }
       
      }),
      catchError(
        (error: HttpErrorResponse) => {
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          errorMsg = `Error: ${error.error.message}`;
        }
        else {
          if(error.status === 0){
            this.router.navigate(['/error/app-down']);
          
          }
          if(error.status === 403){
            this.router.navigate(['/error/no-access']);
          }
          if(error.status === 404){
            this.router.navigate(['/error/not-found']);
          }
          console.log('this is server side error');
          errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
        }
        console.log(errorMsg);
        return throwError(error);
      })
    );
  }
}